module.exports = __webpack_public_path__ + "static/media/Product_Photos_Packs.91d483de.png";